/** Settings: extra Claude Code logins on this computer, and each project's choice. */
export default {
  logins: "Logins",
  defaultLogin: "Default",
  defaultLoginLine: "This computer's Claude login",
  addLogin: "Add login",
  addLoginTitle: "Add a Claude login",
  loginName: "Name",
  add: "Add",
  rename: "Rename",
  renameLoginTitle: "Rename login",
  remove: "Remove",
  signIn: "Sign in",
  signedIn: "Signed in",
  notSignedIn: "Not signed in",
  checking: "Checking…",
  signingIn: "Opening the sign-in window…",
  finishInBrowser: "Finish signing in in your browser.",
  finishInWindow: "Finish signing in in the sign-in window.",
  useBrowserInstead: "Use my browser instead",
  browserHint:
    "Your browser uses the Claude account it is already signed in to.",
  signedInAs: "Signed in as {account}",
  sameAccount: "Same account as {name}. Sign in again with another account.",
  signInWindowTitle: "Sign in to Claude — {name}",
  stop: "Stop",
  signInFailed: "Sign-in didn't finish. Try again.",
  loginsReadFailed: "Couldn't read the logins.",
  saveFailed: "Couldn't save the login. Try again.",
  removeFailed: "Couldn't remove the login. Try again.",
  removeTitle: "Remove {name}?",
  removeInUse:
    "Used by {projects}. New chats there won't start until you pick another login.",
  listSeparator: ", ",
  claudeLogin: "Claude login",
  notOnThisComputer: "Not on this computer",
} as const;
